// extracted by mini-css-extract-plugin
module.exports = {"mainColumn":"styles_mainColumn__1JBBY","jobEditor":"styles_jobEditor__2XFBf","buttons":"styles_buttons__VcQfS"};